function handleScroll(targetId) {
  const header = document.getElementById("headerTitle");
  const headerHeight = header ? header.clientHeight : 0;
  const targetElement = document.getElementById(targetId);
  const scrollDelay = 10; // 着地ズレ解消のための遅延時間

  if (targetElement) {
    const targetPosition = targetElement.getBoundingClientRect().top;
    const currentScroll = window.scrollY;
    const offsetPosition = targetPosition + currentScroll - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });

    // 着地ズレ解消のために少し時間をおいて再度スクロール
    setTimeout(() => {
      const newTargetPosition = targetElement.getBoundingClientRect().top;
      const newCurrentScroll = window.scrollY;
      const newOffsetPosition =
        newTargetPosition + newCurrentScroll - headerHeight;
      window.scrollTo({
        top: newOffsetPosition,
        behavior: "smooth",
      });
    }, scrollDelay);
  }
}

window.addEventListener("DOMContentLoaded", () => {
  const scrollTriggers = document.querySelectorAll(
    'a[href^="#"], a[href*="#"]',
  );

  scrollTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      const href = trigger.getAttribute("href");
      const targetId = href.slice(1);
      handleScroll(targetId);
    });
  });
});
